import React from 'react';
import { motion } from 'framer-motion';
import { Search, UserCheck, CalendarCheck } from 'lucide-react';
const steps = [{
  id: 1,
  icon: Search,
  title: '浏览服务',
  enTitle: 'Browse Services',
  desc: '在我们的平台上浏览各类按摩服务，查看详细介绍与价格。'
}, {
  id: 2,
  icon: UserCheck,
  title: '选择技师',
  enTitle: 'Choose Therapist',
  desc: '查看技师档案、资质认证及用户评价，选择最适合您的一位。'
}, {
  id: 3,
  icon: CalendarCheck,
  title: '预约体验',
  enTitle: 'Book Experience',
  desc: '在线轻松预约时间，享受专业上门或到店按摩服务。'
}];
export function HowItWorks() {
  return <section className="py-24 bg-white" data-id="element-114">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <div className="text-center mb-20" data-id="element-116">
          <span className="text-[#C9A96E] font-medium tracking-widest uppercase text-sm" data-id="element-117">
            Process
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D5A3D] mt-2" data-id="element-118">
            简单三步，开启舒适之旅
          </h2>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-119">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-[#F5EDE0] -z-10" data-id="element-120"></div>

          {steps.map((step, index) => <motion.div key={step.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="text-center relative" data-id="element-121">
              <div className="w-24 h-24 mx-auto bg-[#FDF8F0] rounded-full border-4 border-white shadow-lg flex items-center justify-center mb-6 relative z-10" data-id="element-122">
                <step.icon className="w-10 h-10 text-[#2D5A3D]" data-id="element-123" />
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-[#C9A96E] rounded-full flex items-center justify-center text-white font-bold font-serif" data-id="element-124">
                  {step.id}
                </div>
              </div>

              <h3 className="text-xl font-bold text-[#1A1A1A] mb-1" data-id="element-125">
                {step.title}
              </h3>
              <p className="text-xs text-[#C9A96E] uppercase tracking-wide mb-4" data-id="element-126">
                {step.enTitle}
              </p>
              <p className="text-[#666] leading-relaxed px-4" data-id="element-127">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}